import { render, staticRenderFns } from "./TicketAbonoMultiple.vue?vue&type=template&id=1222ab86&scoped=true&"
import script from "./TicketAbonoMultiple.vue?vue&type=script&lang=js&"
export * from "./TicketAbonoMultiple.vue?vue&type=script&lang=js&"
import style0 from "./TicketAbonoMultiple.vue?vue&type=style&index=0&id=1222ab86&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1222ab86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
